import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiZeistEindhovenAirportPage() {
  return (
    <CityAirportTemplate
      city="Zeist"
      airport="eindhoven"
      airportName="Eindhoven Airport"
      price={90.00}
      distance="72 km"
      duration="55-60 minuten"
    />
  );
}
